import axios from "axios"

import { referralsUrl } from "../../config/microservicesUrls"

const api_url = referralsUrl()

async function referralAxiosPut(jwt, endpoint, data) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  }

  const x = await axiosObj
    .put(`${api_url}/${endpoint}`, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

async function referralAxiosPost(jwt, endpoint, data) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
      "Content-Type": "application/json",
    },
  }

  const x = await axiosObj
    .post(`${api_url}/${endpoint}`, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

async function referralAxiosGet(jwt, endpoint) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  }

  const x = await axiosObj
    .get(`${api_url}/${endpoint}`, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

export async function referralsApiReferralEntitiesPost(jwt, filters) {
  return await referralAxiosPost(jwt, "ReferralEntities/list", filters)
}

export async function referralsApiReferralLocationsPost(jwt, filters) {
  return await referralAxiosPost(jwt, "ReferralEntities/locations", filters)
}

export async function referralsApiReferralLocationsMappedPost(jwt, filters) {
  return await referralAxiosPost(
    jwt,
    "ReferralEntities/locations/mapped",
    filters
  )
}

export async function referralsApiUserAllocationGet(jwt, uid) {
  return await referralAxiosGet(jwt, "ReferralEntities/userallocations/" + uid)
}

export async function referralsApiUserAddPost(
  jwt,
  organization_id,
  userProfile
) {
  return await referralAxiosPost(
    jwt,
    "ReferralEntities/users/byOrganization/" + organization_id,
    userProfile
  )
}

export async function referralsApiUserGet(jwt, organization_id, user_id) {
  return await referralAxiosGet(
    jwt,
    `ReferralEntities/users/byOrganization/${organization_id}/${user_id}`
  )
}

export async function referralsApiUserEditPut(jwt, userProfile) {
  return await referralAxiosPut(jwt, "ReferralEntities/users", userProfile)
}

export async function referralsApiPractitionerRoleTypesGet(jwt) {
  return await referralAxiosGet(jwt, "Options/PractitionerRoleTypes")
}

export async function referralsApiUserAllocationPut(jwt, uid, refEntities) {
  return await referralAxiosPut(
    jwt,
    "ReferralEntities/userallocations/" + uid,
    refEntities
  )
}

export async function referralsApiReferralEntityGetCategories(jwt) {
  return await referralAxiosGet(jwt, `ReferralEntities/categories`)
}

export async function referralsApiReferralEntityGet(jwt, entityID) {
  return await referralAxiosGet(jwt, `ReferralEntities/${entityID}`)
}

export async function referralsApiReferralEntityGetByOrganization(
  jwt,
  organization_id
) {
  return await referralAxiosGet(
    jwt,
    `ReferralEntities/byOrganization/${organization_id}`
  )
}

export async function refApiReferralEntityCheckName(
  jwt,
  partnerId,
  partnerName
) {
  return await referralAxiosPost(jwt, "ReferralEntities/nameCheck", {
    id: partnerId,
    name: partnerName,
    resultLimit: 5,
  })
}

export async function refApiReferralEntityValidate(
  jwt,
  partnerId,
  partnerName
) {
  return await referralAxiosPost(jwt, "ReferralEntities/validate", {
    id: partnerId,
    name: partnerName,
  })
}

export async function refApiReferralEntityCreate(jwt, referralEntity) {
  return await referralAxiosPost(jwt, "ReferralEntities", referralEntity)
}

export async function refApiReferralEntityUpdate(jwt, referralEntity) {
  return await referralAxiosPut(jwt, "ReferralEntities", referralEntity)
}

export async function refApiReferralEntityChangeRequest(jwt, changeRequest) {
  return await referralAxiosPost(
    jwt,
    "ReferralEntities/changeRequest",
    changeRequest
  )
}

export async function refApiReferralEntityChangeRequestProcess(
  jwt,
  changeRequest
) {
  return await referralAxiosPost(
    jwt,
    "ReferralEntities/changeRequest/process",
    changeRequest
  )
}

export async function refApiReferralsGet(jwt) {
  return await referralAxiosGet(jwt, "Referrals")
}

export async function refApiLocationTypesGet(jwt) {
  return await referralAxiosGet(jwt, "Options/ServiceDeliveryLocationRoleTypes")
}

export async function refApiServiceCategoriesGet(jwt) {
  return await referralAxiosGet(jwt, "ReferralEntities/categories")
}

export async function refApiReferralEntityChangeLogGet(jwt, payload) {
  return await referralAxiosPost(
    jwt,
    "ReferralEntities/changelog/list",
    payload
  )
}
